<div class="portfolio-header">
	<h1 class="section-header text-18-bold margin-bottom-10" dcrHTMLKey="GENERATE_PDF_PORTFOLIOS_HEADER">PORTFOLIOS</h1>
	<section class="portfolio-list row">
		<span *ngFor="let portfolio of portfolios" class="portfolio text-16-bold" [ngClass]="columnClass">
			<img ada-decorative [remote-src]="portfolioImageMap.get(portfolioName)" onerror="this.style.display = 'none'" />
			{{ portfolio.name }}
		</span>
	</section>
</div>
